import type { Comment, User } from "@brookbush/database";

import { useAuth } from "@clerk/nextjs";
import { CornerDownLeft, Trash2 } from "lucide-react";
import { FiEdit } from "react-icons/fi";

import CommentAction from "./CommentAction";

interface CommentActionsProps {
	comment: Comment & {
		user: User;
	};

	handleAddReply: () => void;
	handleEdit: () => void;
	handleDelete: () => void;
}

const CommentActions = ({
	comment,
	handleAddReply,
	handleDelete,
	handleEdit,
}: CommentActionsProps) => {
	const { userId } = useAuth();

	if (!userId) return null;

	return (
		<div className="flex items-center gap-3">
			{userId && (
				<CommentAction
					icon={CornerDownLeft}
					label="Reply"
					onClick={handleAddReply}
				/>
			)}
			{userId === comment.userId && (
				<CommentAction icon={FiEdit} label="Edit" onClick={handleEdit} />
			)}
			{userId === comment.userId && (
				<CommentAction icon={Trash2} label="Delete" onClick={handleDelete} />
			)}
		</div>
	);
};

export default CommentActions;
